import TrainingResourcePDFs from './component.jsx'
export default TrainingResourcePDFs
